import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { playSound } from 'containers/App/actions';
import { makeSelectCasinoSoundsOn } from 'containers/App/selectors';
import withSoundLoader from 'utils/withSoundLoader';
import drawingPrizeSound from './drawing.prize.alert.mp3';

export const DRAWING_PRIZE_SOUND = 'drawingPrizeSound';
const DRAWING_PRIZE_SOUNDS = {
  [DRAWING_PRIZE_SOUND]: {
    src: [drawingPrizeSound],
    volume: 1
  }
};

function withDrawingPrizeSound(WrappedComponent) {
  class Sounds extends Component {
    render() {
      const { triggerSound, casinoSoundsOn, ...otherProps } = this.props;

      return (
        <WrappedComponent
          playPrizeSound={() => {
            if (casinoSoundsOn) {
              triggerSound(DRAWING_PRIZE_SOUND);
            }
          }}
          casinoSoundsOn={casinoSoundsOn}
          {...otherProps}
        />
      );
    }
  }

  Sounds.propTypes = {
    triggerSound: PropTypes.func,
    casinoSoundsOn: PropTypes.bool
  };

  function mapDispatchToProps(dispatch) {
    return {
      triggerSound: sound => dispatch(playSound(sound))
    };
  }

  const mapStateToProps = createStructuredSelector({
    casinoSoundsOn: makeSelectCasinoSoundsOn()
  });

  const withConnect = connect(mapStateToProps, mapDispatchToProps);
  const withDrawingSoundLoader = withSoundLoader(DRAWING_PRIZE_SOUNDS, true);

  return withConnect(withDrawingSoundLoader(Sounds));
}
export default withDrawingPrizeSound;
